import { render, staticRenderFns } from "./edit-drone-policy-form.vue?vue&type=template&id=67980376&scoped=true&"
import script from "./edit-drone-policy-form.vue?vue&type=script&lang=js&"
export * from "./edit-drone-policy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67980376",
  null
  
)

export default component.exports